module.exports = __webpack_public_path__ + "9c15fe6aa382239fa846a48a98d0814e.svg";